import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d63b202e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-layout" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = { class: "card-header" }
const _hoisted_5 = { class: "btn-group" }
const _hoisted_6 = { class: "card-tools" }
const _hoisted_7 = {
  key: 0,
  class: "nav nav-pills"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "nav-item" }
const _hoisted_10 = { class: "nav-item" }
const _hoisted_11 = { class: "card-body pb-1" }
const _hoisted_12 = { class: "tab-content" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = { class: "card card-themes shadow" }
const _hoisted_15 = { class: "card-header" }
const _hoisted_16 = { class: "card-title" }
const _hoisted_17 = {
  key: 0,
  class: "card-tools"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 1,
  class: "card-tools"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = {
  class: "card-body table-responsive p-0",
  style: {"max-height":"20rem"}
}
const _hoisted_22 = { class: "table table-striped table-head-fixed table-width-auto text-nowrap text-center" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "序号", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "操作", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "状态", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "normal-width text-left" }, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "createName" }, "创建姓名", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "createTime" }, "创建时间", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "modifyName" }, "修改姓名", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { field: "modifyTime" }, "修改时间", -1))
const _hoisted_31 = { key: 0 }
const _hoisted_32 = ["colspan"]
const _hoisted_33 = /*#__PURE__*/_createTextVNode("暂无数据")
const _hoisted_34 = { class: "table-btn-group" }
const _hoisted_35 = { class: "btn-group" }
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { key: 2 }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_43 = {
  key: 1,
  class: "card-body row pb-1"
}
const _hoisted_44 = {
  key: 2,
  class: "overlay hyper-text-themes animate__animated animate__fadeIn"
}
const _hoisted_45 = {
  key: 0,
  class: "overlay hyper-text-themes animate__animated animate__fadeIn"
}
const _hoisted_46 = { class: "content-modal" }
const _hoisted_47 = { class: "row" }

export function render(_ctx, _cache) {
  const _component_app_content_header = _resolveComponent("app-content-header")
  const _component_app_input = _resolveComponent("app-input")
  const _component_app_select = _resolveComponent("app-select")
  const _component_app_attribute_common_card = _resolveComponent("app-attribute-common-card")
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_app_table_page = _resolveComponent("app-table-page")
  const _component_app_attribute_part_card = _resolveComponent("app-attribute-part-card")
  const _component_app_alert = _resolveComponent("app-alert")
  const _component_app_draggable_listview = _resolveComponent("app-draggable-listview")
  const _component_app_select_level = _resolveComponent("app-select-level")
  const _component_app_switch_number = _resolveComponent("app-switch-number")
  const _component_app_modal = _resolveComponent("app-modal")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_content_header),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["card card-outline card-themes", {'card-flex': _ctx.isLoading}])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_app_input, {
                class: "mr-1 mb-0 hand",
                style: {"width":"300px"},
                modelValue: _ctx.projectInfo.projectName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.projectInfo.projectName) = $event)),
                onClick: _ctx.projectIdLevelModalOpen
              }, null, 8, ["modelValue", "onClick"]),
              _createVNode(_component_app_select, {
                class: "mb-0",
                modelValue: _ctx.layerId,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.layerId) = $event)),
                options: _ctx.projectLevelOptions,
                "onUpdate:onValueChange": _ctx.layerIdChange
              }, null, 8, ["modelValue", "options", "onUpdate:onValueChange"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              (_ctx.projectModelAttribute.child && _ctx.projectModelAttribute.child.length > 0)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectModelAttribute.child, (item, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "nav-item",
                        key: 'nav'+item.modelCode+index
                      }, [
                        _createElementVNode("button", {
                          type: "button",
                          class: _normalizeClass(["btn", {'btn-themes':_ctx.tabIndex===item.modelCode}]),
                          onClick: $event => (_ctx.tabIndex=item.modelCode)
                        }, _toDisplayString(item.modelName), 11, _hoisted_8)
                      ]))
                    }), 128)),
                    _createElementVNode("li", _hoisted_9, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["btn", {'btn-themes':_ctx.tabIndex===3}]),
                        onClick: _cache[2] || (_cache[2] = $event => (_ctx.tabIndex=3))
                      }, "在线状态", 2)
                    ]),
                    _createElementVNode("li", _hoisted_10, [
                      _createElementVNode("button", {
                        type: "button",
                        class: _normalizeClass(["btn", {'btn-themes':_ctx.tabIndex===4}]),
                        onClick: _cache[3] || (_cache[3] = $event => (_ctx.tabIndex=4))
                      }, "运维工单", 2)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectModelAttribute.child, (item1, index1) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["tab-pane", {'active':_ctx.tabIndex===item1.modelCode}]),
                  key: 'pane'+item1.modelCode+index1
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectModelAttribute.attributePre, (item, index) => {
                      return (_openBlock(), _createBlock(_component_app_attribute_common_card, {
                        class: "col-xl-2 col-lg-3 col-md-4 col-sm-6",
                        key: item1.modelCode+item.code+index,
                        projectId: _ctx.projectInfo.projectId,
                        layerId: _ctx.layerId,
                        formModelId: _ctx.projectModelAttribute.modelId,
                        formModelType: _ctx.projectModelAttribute.modelType,
                        modelId: item1.modelId,
                        attributeItem: item,
                        attributeValue: _ctx.projectModelAttributeValues,
                        modelValue: item.code,
                        "onUpdate:modelValue": $event => ((item.code) = $event)
                      }, null, 8, ["projectId", "layerId", "formModelId", "formModelType", "modelId", "attributeItem", "attributeValue", "modelValue", "onUpdate:modelValue"]))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item1.attributePre, (item, index) => {
                      return (_openBlock(), _createBlock(_component_app_attribute_common_card, {
                        class: "col-xl-2 col-lg-3 col-md-4 col-sm-6",
                        key: item1.modelCode+item.code+index,
                        projectId: _ctx.projectInfo.projectId,
                        layerId: _ctx.layerId,
                        formModelId: item1.modelId,
                        formModelType: item1.modelType,
                        modelId: item1.modelId,
                        attributeItem: item,
                        attributeValue: _ctx.projectModelAttributeValues,
                        modelValue: item.code,
                        "onUpdate:modelValue": $event => ((item.code) = $event)
                      }, null, 8, ["projectId", "layerId", "formModelId", "formModelType", "modelId", "attributeItem", "attributeValue", "modelValue", "onUpdate:modelValue"]))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item1.child, (item2, index2) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "col-12",
                        key: 'part'+item1.modelCode+item2.modelCode+index2
                      }, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("h3", _hoisted_16, _toDisplayString(item2.modelName) + " (" + _toDisplayString(_ctx.projectModelAttribute.modelCode+"-"+item1.modelCode+"-"+item2.modelCode) + " = " + _toDisplayString(item2.modelId) + ")", 1),
                            (item2.modelObject==='multiple')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-tool",
                                    onClick: $event => (_ctx.addAttributeMultipleModalOpen(item2))
                                  }, [
                                    _createVNode(_component_svg_icon, {
                                      class: "nav-icon",
                                      name: "add",
                                      size: "md"
                                    })
                                  ], 8, _hoisted_18)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-tool",
                                    onClick: $event => (_ctx.editAttributeSingleModalOpen(item2))
                                  }, [
                                    _createVNode(_component_svg_icon, {
                                      class: "nav-icon",
                                      name: "pencil-outline",
                                      size: "sm"
                                    })
                                  ], 8, _hoisted_20)
                                ]))
                          ]),
                          (item2.modelObject==='multiple')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("div", _hoisted_21, [
                                  _createElementVNode("table", _hoisted_22, [
                                    _createElementVNode("thead", null, [
                                      _createElementVNode("tr", {
                                        ref_for: true,
                                        ref: `tableTr_${_ctx.getModelIdIndex(item2)}`
                                      }, [
                                        _hoisted_23,
                                        _hoisted_24,
                                        _hoisted_25,
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item2.attributeJson, (item, index) => {
                                          return (_openBlock(), _createElementBlock("th", {
                                            key: item1.modelCode+item2.modelCode+item.code+index+'title'
                                          }, _toDisplayString(item.name), 1))
                                        }), 128)),
                                        _hoisted_26,
                                        _hoisted_27,
                                        _hoisted_28,
                                        _hoisted_29,
                                        _hoisted_30
                                      ], 512)
                                    ]),
                                    _createElementVNode("tbody", null, [
                                      (_ctx.attributeMultipleTableTableItems[_ctx.getModelIdIndex(item2)].length<1)
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_31, [
                                            _createElementVNode("td", {
                                              colspan: _ctx.getTableTrLength(_ctx.$refs[`tableTr_${_ctx.getModelIdIndex(item2)}`])
                                            }, [
                                              _createVNode(_component_svg_icon, { name: "alert" }),
                                              _hoisted_33
                                            ], 8, _hoisted_32)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attributeMultipleTableTableItems[_ctx.getModelIdIndex(item2)], (item3, i) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                          key: item3.projectId+item3.layerId+item3.modelId+item3.sortId,
                                          class: _normalizeClass({'text-red': parseInt(item3.statusId)===2})
                                        }, [
                                          _createElementVNode("td", null, _toDisplayString(i+1), 1),
                                          _createElementVNode("td", _hoisted_34, [
                                            _createElementVNode("div", _hoisted_35, [
                                              _createElementVNode("button", {
                                                type: "button",
                                                class: "btn btn-themes",
                                                onClick: $event => (_ctx.modAttributeMultipleModalOpen(item2, item3))
                                              }, [
                                                _createVNode(_component_svg_icon, { name: "settings-outline" })
                                              ], 8, _hoisted_36),
                                              _createElementVNode("button", {
                                                type: "button",
                                                class: "btn btn-themes",
                                                onClick: $event => (_ctx.delAttributeMultipleModalOpen(item3))
                                              }, [
                                                _createVNode(_component_svg_icon, { name: "trash-outline" })
                                              ], 8, _hoisted_37),
                                              _createElementVNode("button", {
                                                type: "button",
                                                class: "btn btn-themes",
                                                onClick: $event => (_ctx.attributeMultipleSortListView(item2, item3))
                                              }, [
                                                _createVNode(_component_svg_icon, { name: "git-compare-outline" })
                                              ], 8, _hoisted_38)
                                            ])
                                          ]),
                                          (parseInt(item3.statusId)===1)
                                            ? (_openBlock(), _createElementBlock("td", {
                                                key: 0,
                                                class: "hand",
                                                onClick: $event => (_ctx.attributeMultipleToggleStatus(item3))
                                              }, [
                                                _createVNode(_component_svg_icon, {
                                                  name: "checkmark-circle-outline",
                                                  class: "hyper-text-themes"
                                                })
                                              ], 8, _hoisted_39))
                                            : (parseInt(item3.statusId)===2)
                                              ? (_openBlock(), _createElementBlock("td", {
                                                  key: 1,
                                                  class: "hand",
                                                  onClick: $event => (_ctx.attributeMultipleToggleStatus(item3))
                                                }, [
                                                  _createVNode(_component_svg_icon, {
                                                    name: "close-circle-outline",
                                                    class: "text-red"
                                                  })
                                                ], 8, _hoisted_40))
                                              : (_openBlock(), _createElementBlock("td", _hoisted_41, "未知")),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item2.attributeJson, (item, index) => {
                                            return (_openBlock(), _createElementBlock("td", {
                                              key: item3.projectId+item3.layerId+item3.modelId+item3.sortId+item.code
                                            }, _toDisplayString(item3.attributeJson[item.code]), 1))
                                          }), 128)),
                                          _hoisted_42,
                                          _createElementVNode("td", null, _toDisplayString(item3.createName), 1),
                                          _createElementVNode("td", null, _toDisplayString(item3.createTime), 1),
                                          _createElementVNode("td", null, _toDisplayString(item3.modifyName), 1),
                                          _createElementVNode("td", null, _toDisplayString(item3.modifyTime), 1)
                                        ], 2))
                                      }), 128))
                                    ])
                                  ])
                                ]),
                                _createVNode(_component_app_table_page, {
                                  class: "card-footer",
                                  pageItems: _ctx.attributeMultipleTablePageItems[_ctx.getModelIdIndex(item2)],
                                  pageFunction: _ctx.attributeMultipleFunction[_ctx.getModelIdIndex(item2)]
                                }, null, 8, ["pageItems", "pageFunction"])
                              ], 64))
                            : (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectModelAttribute.attributeIn, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_app_attribute_part_card, {
                                    class: "col-xl-3 col-lg-4 col-md-6",
                                    key: item1.modelCode+item2.modelCode+item.code+index,
                                    projectId: _ctx.projectInfo.projectId,
                                    layerId: _ctx.layerId,
                                    formModelId: _ctx.projectModelAttribute.modelId,
                                    formModelType: _ctx.projectModelAttribute.modelType,
                                    modelId: item2.modelId,
                                    attributeItem: item,
                                    attributeValue: _ctx.projectModelAttributeValues,
                                    modelValue: item.code,
                                    "onUpdate:modelValue": $event => ((item.code) = $event)
                                  }, null, 8, ["projectId", "layerId", "formModelId", "formModelType", "modelId", "attributeItem", "attributeValue", "modelValue", "onUpdate:modelValue"]))
                                }), 128)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item1.attributeIn, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_app_attribute_part_card, {
                                    class: "col-xl-3 col-lg-4 col-md-6",
                                    key: item1.modelCode+item2.modelCode+item.code+index,
                                    projectId: _ctx.projectInfo.projectId,
                                    layerId: _ctx.layerId,
                                    formModelId: item1.modelId,
                                    formModelType: item1.modelType,
                                    modelId: item2.modelId,
                                    attributeItem: item,
                                    attributeValue: _ctx.projectModelAttributeValues,
                                    modelValue: item.code,
                                    "onUpdate:modelValue": $event => ((item.code) = $event)
                                  }, null, 8, ["projectId", "layerId", "formModelId", "formModelType", "modelId", "attributeItem", "attributeValue", "modelValue", "onUpdate:modelValue"]))
                                }), 128)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item2.attributePre, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_app_attribute_part_card, {
                                    class: "col-xl-3 col-lg-4 col-md-6",
                                    key: item1.modelCode+item2.modelCode+item.code+index,
                                    projectId: _ctx.projectInfo.projectId,
                                    layerId: _ctx.layerId,
                                    formModelId: item2.modelId,
                                    formModelType: item2.modelType,
                                    modelId: item2.modelId,
                                    attributeItem: item,
                                    attributeValue: _ctx.projectModelAttributeValues,
                                    modelValue: item.code,
                                    "onUpdate:modelValue": $event => ((item.code) = $event)
                                  }, null, 8, ["projectId", "layerId", "formModelId", "formModelType", "modelId", "attributeItem", "attributeValue", "modelValue", "onUpdate:modelValue"]))
                                }), 128))
                              ])),
                          (_ctx.isLoading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                _createVNode(_component_svg_icon, {
                                  name: "ali-loading",
                                  size: "xl",
                                  class: "turn"
                                })
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ])
                ], 2))
              }), 128)),
              _createElementVNode("div", {
                class: _normalizeClass(["tab-pane", {'active':_ctx.tabIndex===3}])
              }, " tab3 ", 2),
              _createElementVNode("div", {
                class: _normalizeClass(["tab-pane", {'active':_ctx.tabIndex===4}])
              }, " tab4 ", 2)
            ])
          ]),
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                _createVNode(_component_svg_icon, {
                  name: "ali-loading",
                  size: "xl",
                  class: "turn"
                })
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ]),
    _createElementVNode("section", _hoisted_46, [
      _createVNode(_component_app_alert, { ref: "delAttributeMultipleModal" }, null, 512),
      _createVNode(_component_app_draggable_listview, {
        ref: "sortAttributeMultipleModal",
        modelValue: _ctx.attributeMultipleEditSortList,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.attributeMultipleEditSortList) = $event)),
        group: "attributeMultipleSort",
        title: _ctx.attributeMultipleEditSortTitle,
        submitFunction: _ctx.tableAttributeMultipleSortSubmit
      }, null, 8, ["modelValue", "title", "submitFunction"]),
      _createVNode(_component_app_select_level, {
        ref: "projectIdLevel",
        levelType: "onLest",
        levelApi: _ctx.getProjectApi,
        maxParentId: _ctx.authUser.orgCode,
        selectItem: _ctx.tableRequestItem.lockItem.projectId,
        selectFunction: _ctx.projectIdLevelFunction,
        searchFieldList: _ctx.projectIdLevelSearchField
      }, null, 8, ["levelApi", "maxParentId", "selectItem", "selectFunction", "searchFieldList"]),
      _createVNode(_component_app_modal, {
        ref: "editAttribute",
        title: _ctx.attributeMultipleEditModalTitle,
        submitButtonName: _ctx.attributeMultipleEditModalSubmitButtonName,
        size: "lg",
        submitFunction: _ctx.editAttributeMultipleSubmit,
        submitAfterClose: true
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_47, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attributeMultipleEditModalField, (item, index) => {
              return (_openBlock(), _createBlock(_component_app_input, {
                key: 'editAttribute'+item.code+index,
                class: "col-lg-4",
                label: item.name,
                modelValue: _ctx.attributeMultipleEditModalItem.attributeJson[item.code],
                "onUpdate:modelValue": $event => ((_ctx.attributeMultipleEditModalItem.attributeJson[item.code]) = $event)
              }, null, 8, ["label", "modelValue", "onUpdate:modelValue"]))
            }), 128)),
            _createVNode(_component_app_switch_number, {
              class: "col-lg-12",
              label: "数据状态",
              modelValue: _ctx.attributeMultipleEditModalItem.statusId,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.attributeMultipleEditModalItem.statusId) = $event)),
              enableName: "启用",
              disabledName: "禁用"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _: 1
      }, 8, ["title", "submitButtonName", "submitFunction"])
    ])
  ]))
}